const product = {
  product: "제품", // translated 
  products: "제품", // translated 
  information: "정보", // translated 
  additionalInformation: "추가 정보", // translated 
  contactUs: "문의하기", // translated 
  contactUsText: "투어를 맞춤 설정하고 싶으시거나 다른 질문이 있으신가요?", // translated 
  dropUsAnEmail: "저희에게 이메일을 보내주세요", // translated 
  viewLess: "간략히 보기", // translated 
  viewMore: "더 보기", // translated 
  less: "더 적은", // translated 
  more: "더", // translated 
  highlights: "하이라이트", // translated 
  inclusions: "포함 사항", // translated 
  exclusions: "제외 사항", // translated 
  pleaseWait: "기다리세요...", // translated 
  tourType: "투어 유형", // translated 
  search: "찾다", // translated 
  available: "사용 가능", // translated 
  availableTours: "이용 가능한 투어", // translated 
  sortBy: "정렬 기준", // translated 
  priceLowToHigh: "가격: 낮은 가격부터 높은 가격 순", // translated 
  priceHighToLow: "가격: 높은 가격순에서 낮은 가격순으로", // translated 
  mostPopular: "가장 인기 있는", // translated 
  roomOnly: "객실만", // translated 
  bedAndBreakfast: "민박", // translated 
  halfBoard: "하프보드", // translated 
  fullBoard: "풀보드", // translated 
  allInclusive: "올인클루시브", // translated 
  viewDetails: "상세 정보 보기", // translated 
  close: "닫다", // translated 
  at: "~에", // At dat, // translated 
  person: "사람", // translated 
  cancellationPolicy: "취소 정책", // translated 
  cancellationIs: "취소는", // translated 
  to: "에게", // translated 
  bookingRemarks: "예약 관련 비고", // translated 
  totalPrice: "총 가격", // translated 
  back: "뒤쪽에", // translated 
  bookNow: "지금 예약하세요", // translated 
  minutes: "분", // translated 
  visitDuration: "방문 기간", // translated 
  itinerary: "여행 일정", // translated 
  airportToHotel: "공항에서 호텔까지", // translated 
  hotelToAirport: "호텔에서 공항까지", // translated 
  details: "세부", // translated 
  servicesDetails: "서비스 상세 정보", // translated 
  services: "서비스", // translated 
  day: "낮", // translated 
  next: "다음", // translated 
  nextStep: "다음 단계", // translated 
  skip: "건너뛰다", // translated 
  remarks: "비고", // translated 
  optional: "선택 과목", // translated 
  guests: "손님", // translated 
  payment: "지불", // translated 
  pickup: "찾다", // translated 
  featuredPackage: "추천 패키지", // translated 
  flights: "항공편", // translated 
  accommodation: "숙소", // translated 
  transfers: "이적", // translated 
  tours: "투어", // translated 
  experiences: "경험담", // translated 
  featuredTour: "추천 투어", // translated 
  From: "에서", // translated 
  Accommodation: "숙소", // translated 
  approxDuration: "예상 소요 시간", // translated 
  travellerInformation: "여행자 정보", // translated 
  bookingOverview: "예약 개요", // translated 
  checkout: "점검", // translated 
  paymentFailed: "결제 실패", // translated 
  paymentSuccess: "결제 성공", // translated 
  night: "밤", // translated 
  nights: "밤들", // translated 
  viewEscapes: "뷰 이스케이프", // translated 
  viewExperience: "경험 보기", // translated 
  escapeType: "이스케이프 유형", // translated 
  adultsOnly: "성인 전용", // translated 
  totalDuration: "총 소요 시간", // translated 
  options: "옵션", // translated 
  departingAirport: "출발 공항", // translated 
  childrenAreNotAllowedInThisTour: "이 투어에는 어린이는 참여할 수 없습니다.", // translated 
};


export default product;
